export const T1_ROLE = {
  INTERNAL: 5,
  AGENCY: 6,
} as const;
